import { render, staticRenderFns } from "./PrudentValueTaskStatus.vue?vue&type=template&id=97a4937a&"
import script from "./PrudentValueTaskStatus.vue?vue&type=script&lang=js&"
export * from "./PrudentValueTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports